import styled from 'styled-components'
import { ellipsis } from 'polished'

import { Text } from 'components/Box'
import Dropdown from 'components/Dropdown'

export const Label = styled(Text)`
  ${ellipsis()};
  flex: 1;
  max-width: calc(100% - 1rem);
`

export const DropdownContent = styled.div`
  width: 100%;
  max-height: 40vh;
  overflow-y: auto;
`
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
`
